module.exports = "/_next/static/images/image-blog-d5af56636e0011b609c6ba0d5f5f3d62.png.webp";